import { Warehouse as ApiWarehouse } from "randmar-api-client";
import { Building2, Mail, MapPin, Phone, User } from "lucide-react";
import React from "react";
import { Card } from "randmarcomps";

interface IProps {
  warehouse: ApiWarehouse;
}

const WarehouseInfoCard: React.FC<IProps> = ({ warehouse }) => {
  const cityProvince = [warehouse.City, warehouse.Province].filter(Boolean).join(", ");

  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border">
      <div className="grid min-w-0 grid-cols-[auto_minmax(0,1fr)] items-start gap-6">
        <div className="shrink-0 rounded-full border bg-slate-100 p-3">
          <Building2 className="h-8 w-8 text-slate-600" />
        </div>
        <div className="min-w-0 space-y-5">
          <div>
            {warehouse.Name && <h3 className="text-lg font-medium text-black">
              {warehouse.Name}
            </h3>}
            {warehouse.Country && <p className="text-base text-slate-500">
              {warehouse.Country}
            </p>}
          </div>
          <div className="grid min-w-0 grid-cols-[repeat(auto-fit,minmax(14rem,1fr))] gap-x-8 gap-y-5">
            <div className="min-w-0 space-y-1">
              {warehouse.ContactName && <h3 className="flex min-w-0 items-center gap-2 text-lg font-medium text-black">
                <User className="h-5 w-5 shrink-0 text-slate-400" />
                <span className="min-w-0 break-words">{warehouse.ContactName}</span>
              </h3>}
              {warehouse.ContactEmail && <p className="flex min-w-0 items-center gap-2 text-base text-slate-500">
                <Mail className="h-4 w-4 shrink-0" />
                <span className="min-w-0 break-words">{warehouse.ContactEmail}</span>
              </p>}
              {warehouse.ContactPhone && <p className="flex min-w-0 items-center gap-2 text-base text-slate-500">
                <Phone className="h-4 w-4 shrink-0" />
                <span className="min-w-0 break-words">{warehouse.ContactPhone}</span>
              </p>}
            </div>
            <div className="min-w-0 space-y-1">
              {warehouse.Address1 && <h3 className="flex min-w-0 items-center gap-2 text-lg font-medium text-black">
                <MapPin className="h-5 w-5 shrink-0 text-slate-400" />
                <span className="min-w-0 break-words">{warehouse.Address1}</span>
              </h3>}
              {warehouse.Address2 && <p className="break-words pl-7 text-base text-slate-500">
                {warehouse.Address2}
              </p>}
              {cityProvince && <p className="break-words pl-7 text-base text-slate-500">
                {cityProvince}
              </p>}
              {warehouse.PostalCode && <p className="break-words pl-7 text-base text-slate-500">
                {warehouse.PostalCode}
              </p>}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default WarehouseInfoCard;
